import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { getBtokHeaderInfo } from '@/utils/native/func'
import enUS from './locales/en-US.json'
import koKR from './locales/ko-KR.json'
import viVN from './locales/vi-VN.json'
import zhCN from './locales/zh-CN.json'

const resources = {
  zh: {
    translation: zhCN,
  },
  en: {
    translation: enUS,
  },
  // 韩语
  ko: {
    translation: koKR,
  },
  // 越南语
  vi: {
    translation: viVN,
  },
}

let language = 'zh'
try {
  language = getBtokHeaderInfo()['Accept-Language']
} catch (error) {
  console.error('getBtokHeaderInfo error:', error)
}

void i18n
  .use(initReactI18next) // 集成React
  .init({
    resources,
    fallbackLng: 'zh', // 默认语言
    lng: language,
    interpolation: {
      escapeValue: false, // React已经处理了XSS
    },
  })

export default i18n
